import React from 'react';
import { Box, Stack } from '@curves/ui-base';

import { formatCurrencyFn } from '@Util/utils';
import MemoControllerBox from '@Local/Components/MemoControllerBox';
/**
 * 取得設備租賃帳單失敗清單表格欄位配置
 * 
 * 功能：
 * - 定義扣款失敗清單的表格欄位
 * - 包含會員資訊、交易結果等顯示
 * - 支援金額格式化和特殊顯示邏輯
 * 
 * @returns {Array<Object>} 表格欄位配置陣列
 */
export const getDeviceRentalBillingForFailureRowLabel = () => {
    return [
        {
            cellKey: 'deviceOrderNo',
            headerLabel: '主單編號',
        },
        {
            cellKey: 'contactResult',
            headerLabel: '交易結果',
            formatCell: (cellValue) => {
                return <MemoControllerBox data={cellValue} dialogTitle={'交易結果'} />;
            },
        },
        {
            cellKey: 'clubName',
            headerLabel: '店鋪',
        },
        {
            cellKey: 'memberName',
            headerLabel: '會員',
            formatCell: (memberName, { memberNo }) => {
                return memberName ? (
                    <Stack direction={'column'}>
                        <Box className={'mb-1'}>{memberName}</Box>
                        <Box>{memberNo}</Box>
                    </Stack>
                ) : (
                    <Stack direction={'column'}>
                        <Box className={'font-color-3'}>無法取得對應會員</Box>
                    </Stack>
                );
            },
        },
        {
            cellKey: 'memberCellPhone',
            headerLabel: '手機',
        },
        {
            cellKey: 'transactionPrice',
            headerLabel: '訂單金額',
            formatCell: (cellValue) => {
                return formatCurrencyFn(cellValue, { symbol: '$' });
            },
        },
    ];
};
